import { 
    FETCH_BRANDKIT_FONTS_REQUEST, FETCHING_BRANDKIT_FONTS_SUCCEEDED, FETCHING_BRANDKIT_FONTS_FAILED,
    INITIATE_BRANDKIT_FONT_UPLOAD, UPDATE_BRANDKIT_FONT_UPLOAD_PROGRESS,
    INSTALL_BRANDKIT_FONTS, ASSOCIATE_FONTS_WITH_BRANDKIT_TEXT,
    UPLOAD_BRANDKIT_FONT_REQUEST, UPLOADING_BRANDKIT_FONT_SUCCEEDED, UPLOADING_BRANDKIT_FONT_FAILED,
    DELETE_BRANDKIT_FONT_REQUEST, DELETING_BRANDKIT_FONT_SUCCEEDED, DELETING_BRANDKIT_FONT_FAILED, INVALIDATE_BRANDKIT_FONT_UPLOAD_ERROR,

    CREATE_BRANDKIT_TEXT, DELETE_BRANDKIT_TEXT, UPDATE_BRANDKIT_TEXT_PROPERTY, 
    RENAME_BRANDKIT_TEXT, UPDATE_BRANDKIT_TEXT_CONTENT,
    FETCHING_BRANDKIT_TEXT_REQUEST, FETCHING_BRANDKIT_TEXT_SUCCEEDED, FETCHING_BRANDKIT_TEXT_FAILED,
    DELETE_BRANDKIT_TEXT_REQUEST, DELETING_BRANDKIT_TEXT_SUCCEEDED, DELETING_BRANDKIT_TEXT_FAILED,
    UPDATE_BRANDKIT_TEXT_REQUEST, UPDATING_BRANDKIT_TEXT_SUCCEEDED, UPDATING_BRANDKIT_TEXT_FAILED,
    INVALIDATE_BRANDKIT_TEXT
  } from 'constants/actionTypes';
  import _ from 'lodash';
  
  const initialState = {
    loading: false,
    fetched: false,
    invalidated: false,
    items: [],
    components: [],
    fonts:[],
    installed: [],
    pagination: {
      currentPage: 0,
      totalPages: 0,
    },
    uploads: [],
  }
  
  export function brandKitTextReducer(state = initialState, action) {
    switch (action.type) {
      
      case FETCH_BRANDKIT_FONTS_REQUEST: {
        return {
          ...state,
          loading: true
        }
      }
  
      case FETCHING_BRANDKIT_FONTS_SUCCEEDED: {
        const { records, currentPage, totalPages, recordsPerPage } = action.payload;
    
        if (currentPage !== 0) {
          fonts = [...state.fonts, ...records];
        } else {
          fonts = records;
        }
        
        fonts = _.uniqBy(fonts, 'id');
        
        return {
          ...state,
          loading: false,
          fetched: true,
          fonts: fonts,
          pagination: {
            currentPage: currentPage,
            totalPages: totalPages,
            recordsPerPage: recordsPerPage
          }
        }
      }
  
      case FETCHING_BRANDKIT_FONTS_FAILED: {
        return {
          ...state,
          loading: false,
          error: action.payload
        }
      }
  
      case INITIATE_BRANDKIT_FONT_UPLOAD: {
        const request = action.payload;
        let { name, type } = request;
        const ttfExtension = name.endsWith('.ttf');
  
        if (type !== 'font/ttf' && !ttfExtension){
          return {
            ...state,
            uploadError:true,
          }
        }
  
        var uploads = [...state.uploads, request];
        uploads = _.uniqBy(uploads, 'id');
  
        return {
          ...state,
          uploads: uploads
        }      
      }
      
      case INVALIDATE_BRANDKIT_FONT_UPLOAD_ERROR: {
        return {
          ...state,
          uploadError: false,
        }
      }
      
      case UPDATE_BRANDKIT_FONT_UPLOAD_PROGRESS: {
        const {id, progress} = action.payload;
  
        var uploads = state.uploads.map(font => {
          if(font.id === id){
            return {
              ...font,
              progress: progress
            }
          }
  
          return font;
        })
  
        return {
          ...state,
          uploads: uploads
        }      
      }
  
  
      case UPLOAD_BRANDKIT_FONT_REQUEST:{
        const {id} = action.payload;
  
        var uploads = state.uploads.map(font => {
          if(font.id === id){
            return {
              ...font,
              processing: true
            }
          }
  
          return font;
        })
  
        return {
          ...state,
          uploads: uploads
        }      
      }
  
      case UPLOADING_BRANDKIT_FONT_SUCCEEDED:{
        const {id, response} = action.payload;
  
        var uploads = state.uploads.filter(font => {
          return font.id != id;
        });
        
        var fonts = [response, ...state.fonts];
        fonts = _.uniqBy(fonts, 'id');
        fonts = _.orderBy(fonts, 'createdDate', 'desc');
  
        return {
          ...state,
          uploads: uploads,
          fonts
        }      
      }
  
      case UPLOADING_BRANDKIT_FONT_FAILED:{
        const {id, error} = action.payload;
  
        var uploads = state.uploads.map(font => {
          if(font.id === id){
            return {
              ...font,
              processing: false,
              error: error
            }
          }
  
          return font;
        })
  
        return {
          ...state,
          uploads: uploads
        }      
      }
  
  
      case INSTALL_BRANDKIT_FONTS: {
        const fonts = action.payload || [];
        const ids = fonts.map(font => font.id);
  
        var installed = [...state.installed, ...ids];
        _.uniq(installed);
  
        return {
          ...state,
          installed: installed
        }
      }
  
      case DELETE_BRANDKIT_FONT_REQUEST:{
        const id = action.payload;
  
        return {
          ...state,
          deleting: true,
        }   
      }
  
      case DELETING_BRANDKIT_FONT_SUCCEEDED:{
        const { ids, response } = action.payload;
        
        const fonts = state.fonts.filter(item => (!(ids).includes(item.id)));
  
        return {
          ...state,
          loading: false,
          deleting: false,
          fonts: fonts,
        }
      }
  
      case DELETING_BRANDKIT_FONT_FAILED:{
        return {
          ...state,
          loading: false,
          deleting: false,
          error: action.payload.error[0]
        }   
      }

      case CREATE_BRANDKIT_TEXT: {
        var { component } = action.payload;

        const existingComponents = [...state.components];

        if (existingComponents.length != 0) {
          component = {
            ...component,
            changes: true,
            order: existingComponents.length + 1
          }
        }

        var updatedState = {
          ...state,
          components: [...existingComponents, component],
        }

        return updatedState;
      }

      case DELETE_BRANDKIT_TEXT: {
        const { ids } = action.payload;

        const updatedComponents = state.components.filter(component => !ids.includes(component.id));

        return {
          ...state,
          components: updatedComponents
        }

      }

      case UPDATE_BRANDKIT_TEXT_PROPERTY: {
        const { id, widget_uid, property } = action.payload;
      
        const components = state.components || [];
        
        const updatedComponents = components.map(component => {
          if (component.id === id) {
            const updatedWidgets = component.draft.widgets.map(widget => {
              if (widget.uid === widget_uid) {
                return {
                  ...widget,
                  properties: property
                };
              }
              return widget;
            });
      
            return {
              ...component,
              changes: true,
              draft: {
                ...component.draft,
                widgets: updatedWidgets,
              },
            };
          }
          return component;
        });
      
        return {
          ...state,
          components: updatedComponents,
        };
      }
      
      case UPDATE_BRANDKIT_TEXT_CONTENT: {
        const { id, widget_uid, content, name } = action.payload;

        const components = state.components || [];

        const updatedComponents = components.map(component => {
          if (component.id === id) {
            const updatedWidgets = component.draft.widgets.map(widget => {
              if (widget.uid === widget_uid) {
                return {
                  ...widget,
                  content: content,
                  name
                };
              }
              return widget;
            });
      
            return {
              ...component,
              changes: true,
              draft: {
                ...component.draft,
                widgets: updatedWidgets,
              },
            };
          }
          return component;
        });
      
        return {
          ...state,
          components: updatedComponents,
        };
      }

      case ASSOCIATE_FONTS_WITH_BRANDKIT_TEXT: {
        const { id, widget_uid, fonts } = action.payload;

        const components = state.components || [];

        const updatedComponents = components.map(component => {
          if (component.id === id) {
            const updatedWidgets = component.draft.widgets.map(widget => {
              if (widget.uid === widget_uid) {
                return {
                  ...widget,
                  fonts: fonts
                };
              }
              return widget;
            });
      
            return {
              ...component,
              changes: true,
              draft: {
                ...component.draft,
                widgets: updatedWidgets,
              },
            };
          }
          return component;
        });
      
        return {
          ...state,
          components: updatedComponents,
        };
      }

      case RENAME_BRANDKIT_TEXT: {
        const { id, name } = action.payload;

        const components = state.components || [];

        const updatedComponents = components.map(component => {
          if (component.id === id) {
      
            return {
              ...component,
              changes: true,
              name: name
            };
          }
          return component;
        });
      
        return {
          ...state,
          components: updatedComponents,
        };
      }
  
      case FETCHING_BRANDKIT_TEXT_REQUEST: {
        return {
          ...state,
          text: {
            loading: true
          }
        }
      }
      
      case FETCHING_BRANDKIT_TEXT_SUCCEEDED: {
        return {
          ...state,
          text:{
            loading: false,
            fetched: true
          },
          items: action.payload,
          components: action.payload.components
        }
      }
  
      case FETCHING_BRANDKIT_TEXT_FAILED: {
        return {
          ...state,
          text:{
            loading: false,
          },
          error: action.payload
        }
      }
  
      case DELETE_BRANDKIT_TEXT_REQUEST: {

        return {
            ...state,
            deleting: true,
          }
      }
  
      case DELETING_BRANDKIT_TEXT_SUCCEEDED: {
        const { ids, response } = action.payload;
        
        const components = state.components.filter(item => (!(ids).includes(item.id)));
  
        return {
          ...state,
          loading: false,
          deleting: false,
          components: components,
        }
      }
  
      case DELETING_BRANDKIT_TEXT_FAILED: {
        return {
          ...state,
          deleting: false,
          loading: false,
          error: action.payload.error[0]
        }
      }
  
      case UPDATE_BRANDKIT_TEXT_REQUEST: {
        return {
          ...state,
          loading: true,
          updating: true
        }
      }
        
      case UPDATING_BRANDKIT_TEXT_SUCCEEDED: { 
        const {response} = action.payload;

        return {
          ...state,
          loading: false,
          updated: true,
          updating: false,
          items: response,
          components: response.components
        }
      }
        
      case UPDATING_BRANDKIT_TEXT_FAILED: {
        return {
          ...state,
          updating: false,
          loading: false,
          error: action.payload.error[0]
        }
      }

      case INVALIDATE_BRANDKIT_TEXT: {
        return {
          ...state,
          loading: false,
          updating: false,
          updated: false,
          fetched: false,
          invalidated: false,
          errorType: null,
          invalidated: false
        }
      }
  
      default:
        return state;
    }
  }